import { createSelector } from '@ngrx/store';

import { RootState } from '../../root-store/root.state';
import { SeSideComponentType } from '../se-side-components/se-side-components-models';

export const selectSeSideComponentFeatureState = (state: RootState) => state.seSideNav;

const SideNavIndexing: Record<SeSideComponentType, number> = {
    [SeSideComponentType.reporting]: 0,
    [SeSideComponentType.patientHistory]: 1,
    [SeSideComponentType.keyImagesPreview]: 2,
    [SeSideComponentType.reportPreview]: 3,
    [SeSideComponentType.details]: 4,
};
export const selectActiveSeSideComponentState = createSelector(selectSeSideComponentFeatureState, (state) => {
    const sortedTabs = Object.entries(state).filter(([_, component]) => component.active);
    sortedTabs.sort((a, b) => SideNavIndexing[a[0]] - SideNavIndexing[b[0]]);//per sonarqube
    return sortedTabs.map(([type, component]) => ({ ...component, type }));
});
